import { Card, Eyebrow } from '../../_components/primitives';

const ROWS = [
  { title: '3 guesses', body: 'Photo zooms out each miss.' },
  {
    title: 'Score per axis',
    body: 'Make + model + generation earn independently.',
  },
  {
    title: 'Earlier = more',
    body: 'First guess earns 3 pts per axis, second 2, third 1.',
  },
];

export function HowToPlayCard() {
  return (
    <Card padded={false}>
      <div style={{ padding: '16px 20px 6px' }}>
        <Eyebrow tone="denim">How to play</Eyebrow>
      </div>
      <div
        style={{
          padding: '4px 20px 18px',
          display: 'flex',
          flexDirection: 'column',
          gap: 10,
        }}
      >
        {ROWS.map((r) => (
          <div
            key={r.title}
            style={{
              display: 'grid',
              gridTemplateColumns: '120px minmax(0, 1fr)',
              gap: 14,
              alignItems: 'baseline',
            }}
          >
            <span
              style={{
                fontFamily: 'var(--font-display)',
                fontWeight: 200,
                fontSize: 16,
                color: 'var(--fg-1)',
              }}
            >
              {r.title}
            </span>
            <span
              style={{ fontSize: 13, color: 'var(--fg-2)', fontWeight: 300 }}
            >
              {r.body}
            </span>
          </div>
        ))}
      </div>
    </Card>
  );
}
